import React from 'react';

import { useI18n } from 'i18n';
import { IDraftFormLease } from 'types/tep';
import { IInfoTableCell } from 'types/info-table';
import { Email } from 'components/organisms/tep/tep-management/modals/draft-modal/cells/email';
import { Since } from 'components/organisms/tep/tep-management/modals/draft-modal/cells/since';
import { Until } from 'components/organisms/tep/tep-management/modals/draft-modal/cells/until';
import { Actions } from 'components/organisms/tep/tep-management/modals/draft-modal/cells/actions';
import { Company } from 'components/organisms/tep/tep-management/modals/draft-modal/cells/company';
import { PlateNumber } from 'components/organisms/tep/tep-management/modals/draft-modal/cells/plate-number';

export const useDraftColumns = ({ isMultiple }: { isMultiple: boolean }) => {
  const { fc } = useI18n();

  const getCompanyCell = (cell: IInfoTableCell<IDraftFormLease, string>) => <Company rowIndex={cell.row.index} />;

  const getEmailCell = (cell: IInfoTableCell<IDraftFormLease, string>) => <Email rowIndex={cell.row.index} />;

  const getPlateNumberCell = (cell: IInfoTableCell<IDraftFormLease, string>) => (
    <PlateNumber rowIndex={cell.row.index} />
  );

  const getSinceCell = (cell: IInfoTableCell<IDraftFormLease, string>) => <Since rowIndex={cell.row.index} />;

  const getUntilCell = (cell: IInfoTableCell<IDraftFormLease, string>) => <Until rowIndex={cell.row.index} />;

  const getActionsCell = (cell: IInfoTableCell<IDraftFormLease, string>) => <Actions rowIndex={cell.row.index} />;

  return [
    {
      header: fc('name'),
      accessorKey: 'name',
      cell: (cell: IInfoTableCell<IDraftFormLease, string>) => <div>{cell.row.name}</div>,
      width: 100,
      minWidth: 100,
    },
    { header: fc('IMEI'), accessorKey: 'uri', minWidth: 160 },
    { header: fc('company'), accessorKey: 'company', cell: getCompanyCell, minWidth: 120 },
    { header: fc('emails'), accessorKey: 'email', cell: getEmailCell, minWidth: 120 },
    { header: fc('Vehicle Plate No'), accessorKey: 'plateNumber', cell: getPlateNumberCell, minWidth: 120 },
    { header: fc('TEP Start'), accessorKey: 'startOn', cell: getSinceCell, minWidth: 120 },
    { header: fc('TEP End'), accessorKey: 'endOn', cell: getUntilCell, minWidth: 120 },
    ...(isMultiple
      ? [{ accessorKey: 'actions', header: fc('actions'), cell: getActionsCell, width: 130, minWidth: 130 }]
      : []),
  ];
};
